import React from 'react';

import { ICONS } from 'constants/icons';
import { MANAGE_SERVICES_TAB } from 'constants/logic';
import EmptyState from '../../EmptyState';
import { messages } from '../Services.messages';

const ServicesEmpty = () => (
  <EmptyState
    headerMessage={messages.empty.header}
    subheaderMessage={messages.empty.subheader}
    buttonMessage={messages.empty.button}
    tab={MANAGE_SERVICES_TAB.SERVICES}
    iconSource={ICONS.servicesEmpty}
    iconTitleMessage={messages.empty.emptyIcon}
  />
);

export default ServicesEmpty;
